import { render, staticRenderFns } from "./PosDetails.vue?vue&type=template&id=062db374&scoped=true&"
import script from "./PosDetails.vue?vue&type=script&lang=js&"
export * from "./PosDetails.vue?vue&type=script&lang=js&"
import style0 from "./PosDetails.vue?vue&type=style&index=0&id=062db374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062db374",
  null
  
)

export default component.exports